import React, { memo, useRef, useState } from "react";
import moment from "moment";
import ReactDatepicker from "react-datepicker";
import { setMinutes, setHours } from "date-fns";
import Label from "../Label/Label";
import HintLabel from "../HintLabel/HintLabel";
import ErrorLabelWithValue from "../ErrorLabelWithValue/ErrorLabelWithValue";
import InfoIcon from "../InfoIcon/InfoIcon";
import "react-datepicker/dist/react-datepicker.css";
import InputDescription from "../InputDescription/InputDescription";
import PendingFieldConfirmButton from "../PendingFieldConfirmButton/PendingFieldConfirmButton";
import { getBrowserLocale, isFocused } from "../../utilities";
import DATE_FORMATS from "../../date-formats.json";
import "./datepicker.scss";

const Datepicker = memo((props) => {
  const {
    id,
    label,
    presentationType,
    placeholder,
    description,
    hintText,
    value,
    disabled,
    error,
    pending,
    isRequired,
    validations,
    onChange,
  } = props;
  const [show, setShow] = useState(false);
  const datepickerRef = useRef(null);
  const locale = getBrowserLocale(navigator.language);

  const handleToggle = () => setShow(!show);

  const getDate = (value) => {
    return value ? moment(value).toDate() : "";
  };

  const getLocale = (locale) => {
    try {
      return require(`date-fns/locale/${locale}/index.js`);
    } catch (error) {
      return require('date-fns/locale/en-US/index.js');
    }
  };

  const getDateFormat = (locale = "en-Us", type) => {
    const format =  DATE_FORMATS[locale]
    if(type === "datetime"){
      return format + ' h:mm aa';
    }
    return format;
  };

  const getValidDate = (validateType) => {
    const validation = validations.find(({ type }) => type === validateType);
    return validation ? moment(moment(validation.params[0])).toDate() : null;
  };

  return (
    <div className="input-field dcrform-datepicter">
      <Label className={pending ? "pending-label" : ""}>{label}</Label>
      <div className="input-field__wrapper">
        <div className="input-field__inner-wrapper">
          <div className="input-field__confirm-wrapper">
            <ReactDatepicker
              ref={datepickerRef}
              className={`input-field__input ${isRequired ? "error-border" : ""}`}
              name={id}
              selected={getDate(value)}
              disabled={disabled}
              locale={getLocale(locale)}
              placeholderText={placeholder}
              onChange={(date) => {
                onChange(moment(date).toISOString());
              }}
              dateFormat={getDateFormat(locale, presentationType)}
              showTimeSelect={presentationType === "datetime"}
              minDate={getValidDate("min")}
              maxDate={getValidDate("max")}
              minTime={setMinutes(getValidDate("min"), 0)}
              maxTime={setHours(setMinutes(getValidDate("max"), 45), 23)}
              autoComplete="none"
            />
            {pending && value && !isFocused(datepickerRef.current?.input) && (
              <PendingFieldConfirmButton onClick={() => onChange(value)} />
            )}
          </div>
          {description && <InfoIcon onClick={handleToggle} active={show} />}
        </div>
        <ErrorLabelWithValue
          isRequired={isRequired}
          error={error}
          validations={validations}
        />
        {hintText && <HintLabel>{hintText}</HintLabel>}
        {description && show && (
          <InputDescription>{description}</InputDescription>
        )}
      </div>
    </div>
  );
});

export default Datepicker;
